import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCannabis } from '@fortawesome/free-solid-svg-icons'; 
import './App.css';
import backgroundImage from './bg.webp';
import logo from './logo.png';
import graph from './graph.webp';
function App() {
  return (

    <div
      className="niche-container"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        color: '#fff',
      }}
    >
      <div className="container">
        <div className="logo">
          <img src={logo} />
        </div>
        <div className="graph">
          <img src={graph} />
        </div>
        <header className="niche-header">
          <h1 className="niche-title">The Future In Health & Wellness</h1>
          <p className="niche-subtitle">Entering the global market of Phytopharmaceuticals.</p>
        </header>

        <div className="niche-buttons">
        <button className="btn">Hemp Products  <FontAwesomeIcon icon={faCannabis} className="leaf-icon" /> </button>
          <button className="btn">Ayurvedic Products  <FontAwesomeIcon icon={faCannabis} className="leaf-icon" /> </button>
          <button className="btn">Consultation  <FontAwesomeIcon icon={faCannabis} className="leaf-icon" /> </button>
          <button className="btn">Explore PhytoPharma  <FontAwesomeIcon icon={faCannabis} className="leaf-icon" /> </button>
        </div>
      </div>
    </div>
  );
}
export default App;
